import { defineMessages, IntlShape } from "react-intl";

import NumberFormatType from "@mapmycustomers/shared/enum/NumberFormatType";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages({
  [NumberFormatType.NUMERIC]: {
    id: "numberFormatType.number.withComma",
    defaultMessage: "Number (with commas)",
    description: "Name of the numeric type number on the Manage Fields",
  },
  [NumberFormatType.NUMERIC_NO_COMMA]: {
    id: "numberFormatType.number.noComma",
    defaultMessage: "Number (without commas)",
    description: "Name of the numeric type number without commas on the Manage Fields",
  },
  [NumberFormatType.PERCENTAGE]: {
    id: "numberFormatType.percent",
    defaultMessage: "Percent",
    description: "Name of the numeric type percent on the Manage Fields",
  },
});

const getNumberFormatTypeDisplayName = (intl: IntlShape, formatType: NumberFormatType): string =>
  getDisplayName(intl, messages, formatType, "NumberFormatType");

export default getNumberFormatTypeDisplayName;
